module.exports = __webpack_public_path__ + "img/03.6522ab65.svg";